(() => {
  const dataElement = document.getElementById('f24-promotion-data');
  if (!dataElement) return;
  const config = JSON.parse(dataElement.textContent);
  const offers = new Set(config.loisachtaler);
  const offerTemplate = document.getElementById('f24-loisa-promotion-template');
  const searchProducts = new Map();
  const searchQueue = [];
  let activeRequests = 0;
  const loadSearchProducts = () => {
    while (activeRequests < 4 && searchQueue.length) {
      const { handle, path } = searchQueue.shift();
      activeRequests++;
      fetch(`${path}.js`, { credentials: 'same-origin' })
        .then(response => response.ok ? response.json() : null)
        .then(product => { searchProducts.set(handle, product); })
        .catch(() => { searchProducts.set(handle, null); })
        .finally(() => { activeRequests--; schedule(); loadSearchProducts(); });
    }
  };
  const searchCards = () => {
    document.querySelectorAll('.gl-product-card').forEach(card => {
      const link = card.querySelector('a[href*="/products/"]');
      const media = card.querySelector('.gl-card-media');
      if (!link || !media) return;
      const url = new URL(link.href, location.origin);
      const handle = decodeURIComponent(url.pathname.split('/products/')[1] || '');
      if (!handle || url.origin !== location.origin) return;
      if (offers.has(handle) && !media.querySelector('.f24-loisa-gratis') && offerTemplate?.content.firstElementChild) {
        media.append(offerTemplate.content.cloneNode(true));
      }
      if (!searchProducts.has(handle)) {
        searchProducts.set(handle, null);
        searchQueue.push({handle, path:url.pathname});
        loadSearchProducts();
      }
      const product = searchProducts.get(handle);
      if (!product?.variants) return;
      const priceText = card.querySelector('.gl-card-price')?.textContent || '';
      const price = Math.round(Number(priceText.replace(/[^0-9.,]/g, '').replace(',', '.')) * 100);
      const variant = product.variants.find(item => item.price === price);
      if (!variant) return;
      let badge = media.querySelector('.f24-search-percent');
      const discounted = variant.compare_at_price > variant.price;
      if (!discounted) {
        if (badge) badge.remove();
        card.querySelector('.f24-search-compare')?.remove();
        return;
      }
      const discount = Math.round((1 - variant.price / variant.compare_at_price) * 100);
      const text = discount > 0 ? `${discount}%` : '<1%';
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'spf-product__label-sale f24-search-percent';
        badge.append(document.createElement('strong'));
        media.append(badge);
      }
      if (badge.firstElementChild.textContent !== text) badge.firstElementChild.textContent = text;
      const label = config.percentLabel.replace('__discount__', discount > 0 ? discount : '<1').replace(config.upTo, '').trim();
      if (badge.getAttribute('aria-label') !== label) badge.setAttribute('aria-label', label);
      const pricing = card.querySelector('.gl-card-pricing');
      if (pricing && !pricing.querySelector('.f24-search-compare')) {
        const oldPrice = document.createElement('s');
        oldPrice.className = 'f24-search-compare';
        oldPrice.textContent = `CHF ${(variant.compare_at_price / 100).toFixed(2)}`;
        pricing.prepend(oldPrice);
      }
    });
  };
  let queued = false;
  const update = () => {
    queued = false;
    productDiscount();
    searchCards();
    document.querySelectorAll('.spf-product-card').forEach((card) => {
      const inner = card.querySelector('.spf-product-card__inner');
      if (!inner) return;
      const link = inner.querySelector('a[href*="/products/"]:not(.open-quick-view)');
      const match = link?.getAttribute('href').match(/\/products\/([^/?#]+)/);
      const handle = match ? decodeURIComponent(match[1]) : '';
      const offer = inner.querySelector('.f24-loisa-gratis');
      if (offers.has(handle) && !offer && offerTemplate?.content.firstElementChild) {
        inner.append(offerTemplate.content.cloneNode(true));
      } else if (!offers.has(handle) && offer) {
        offer.remove();
      }
      let sale = inner.querySelector('.spf-product__label-sale');
      const select = card.querySelector('.spf-product__variants');
      const option = select?.selectedOptions[0];
      let price = Number(option?.dataset.price);
      let compare = Number(option?.dataset.compare_at_price);
      if (!option) {
        const amount = (selector) => Number((card.querySelector(selector)?.textContent || '').replace(/[^0-9.,]/g, '').replace(',', '.'));
        price = amount('.spf-product-card__saleprice,.spf-product-card__price');
        compare = amount('.spf-product-card__oldprice');
      }
      const discounted = compare > price && price >= 0;
      const discount = discounted ? Math.max(1, Math.round((1 - price / compare) * 100)) : 0;
      if (discounted && !sale) {
        sale = document.createElement('span');
        sale.className = 'spf-product__label spf-product__label-sale';
        inner.append(sale);
      }
      if (sale) {
        sale.hidden = !discounted;
        if (discounted) {
          const label = config.percentLabel.replace('__discount__', discount).replace(config.upTo, '').trim();
          let amount = sale.querySelector('strong');
          if (!amount || sale.querySelector('.f24-promo-prefix')) {
            amount = document.createElement('strong');
            sale.replaceChildren(amount);
          }
          if (amount.textContent !== `${discount}%`) amount.textContent = `${discount}%`;
          if (sale.getAttribute('aria-label') !== label) sale.setAttribute('aria-label', label);
        }
      }
    });
  };
  const productDiscount = () => {
    if (!Array.isArray(config.variants)) return;
    const choices = [...document.querySelectorAll('variant-selects input:checked,variant-selects select')].map(el => el.value);
    const id = document.querySelector('product-info form[action*="/cart/add"] input[name="id"],product-form input[name="id"]')?.value;
    const variant = config.variants.find(v => choices.length && v.options.every((value, i) => value === choices[i])) || config.variants.find(v => String(v.id) === id);
    if (!variant) return;
    const reduction = variant.compare_at_price > variant.price ? Math.max(1, Math.round((1 - variant.price / variant.compare_at_price) * 100)) : 0;
    document.querySelectorAll('.f24-product-percent').forEach(badge => {
      badge.hidden = !reduction;
      const amount = badge.querySelector('strong');
      if (amount && amount.textContent !== `${reduction}%`) amount.textContent = `${reduction}%`;
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  const relevant = (node) => node instanceof Element &&
    (node.closest('.spf-product-card,.gl-product-card,product-info,variant-selects') || node.matches('.spf-product-card,.gl-product-card') || node.querySelector('.spf-product-card,.gl-product-card'));
  new MutationObserver((records) => {
    if (records.some((record) => relevant(record.target) || [...record.addedNodes].some(relevant))) schedule();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-price', 'data-compare_at_price'] });
  document.addEventListener('change', (event) => {
    if (event.target.closest('.spf-product-card,product-info,variant-selects')) schedule();
  });
  update();
})();

